// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__49hkl","content":"LoadingAlert_content__2Aeh9"};